/* Page to fetch all Scenes data and render the cover info 
 * Contains the SceneTop component to which it passes the data
   for each Scene cover */
import React, { useEffect, useLayoutEffect, useState } from "react";

import Col from "react-bootstrap/Col";
import Row from "react-bootstrap/Row";
import Form from "react-bootstrap/Form";
import Container from "react-bootstrap/Container";
import { Button } from "react-bootstrap";
import { useHistory } from "react-router-dom";
import { axiosInstance, axiosReq } from "../../api/axiosDefaults";
import NoResults from "../../assets/no-results.png";
import Asset from "../../components/Asset";
import { useRedirect } from "../../hooks/Redirect";
import SceneTop from "./SceneTop";
import { useSetActContext } from "../../contexts/ActContext";
import TopBox from "../../components/TopBox";
import Information from "./info/Information";
import { useCurrentUser } from "../../contexts/CurrentUserContext";
import { CLIENT_PROGRAM_HOSTNAME } from "../../utils/config";
import useHostName from "../../hooks/useHostName";

import styles from "../../styles/Scene.module.css";
import btnStyles from "../../styles/Button.module.css";
import appStyles from "../../App.module.css";
import InfoFreeze from "./info/InfoFreeze";
import InfoNumbers from "./info/InfoNumbers";
import ProTrackerPage from "./ProTrackerPage";

const ScenesPage = ({ message, filter = "" }) => {
  const host = useHostName();
  useRedirect();
  const currentUser = useCurrentUser();
  const [scenes, setScenes] = useState({ results: [] });
  const [hasLoaded, setHasLoaded] = useState(false);
  const [query, setQuery] = useState("");
  const setAct = useSetActContext();
  const history = useHistory();
  const [showInfo] = useState(false);
  const [showNum, setShowNum] = useState(false);
  const [showInfoFreeze, setShowInfoFreeze] = useState(false);
  const [selectedEpisode, setSelectedEpisode] = useState("");
  const [showTracker, setShowTracker] = useState(false);

  const queryString = window.location.search;

  // Use URLSearchParams to parse the query string
  const params = new URLSearchParams(queryString);
  // Retrieve the "episode" parameter
  const epi = params.get("episode");
  const pro = params.get("project");
  const episodeTitle = params.get("episodeTitle");

  const projectType = currentUser?.project_category_type
    ? JSON.parse(currentUser?.project_category_type)
    : null;

  /* The following 4 functions set the Act the useSetActContext
       for which to fetch the Scenes
     * This will be read in App.js and passed as a filter
       to the /act/scenes Route */
  const handleClickAct1 = () => {
    setAct("one");
    history.push(`/${localStorage.getItem("projectSlug")}/act/scenes`);
  };

  const handleClickAct2a = () => {
    setAct("two-a");
    history.push(`/${localStorage.getItem("projectSlug")}/act/scenes`);
  };

  const handleClickAct2b = () => {
    setAct("two-b");
    history.push(`/${localStorage.getItem("projectSlug")}/act/scenes`);
  };

  const handleClickAct3 = () => {
    setAct("three");
    history.push(`/${localStorage.getItem("projectSlug")}/act/scenes`);
  };

  const fetchScenes = async () => {
    setHasLoaded(false);
    try {
      if (host === CLIENT_PROGRAM_HOSTNAME) {
        const { data } = await axiosReq.get(
          `/scenes/?${filter}&search=${query}`
        );
        setScenes(data);
        setHasLoaded(true);
      } else {
        const { data } = await axiosInstance.get(
          projectType !== "Television" && !epi
            ? `${localStorage.getItem(
                "projectSlug"
              )}/scenes/?${filter}&search=${query}`
            : epi
            ? `${localStorage.getItem(
                "projectSlug"
              )}/scenes/?${filter}&search=${query}&episodeId=${epi}`
            : `${localStorage.getItem(
                "projectSlug"
              )}/scenes/?${filter}&search=${query}`,
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
            },
            withCredentials: true,
          }
        );
        setScenes(data);
        setHasLoaded(true);
      }
    } catch (err) {
      console.log(err);
    }
  };

  useEffect(() => {
    /* Function to fetch all Scenes */

    const timer = setTimeout(() => {
      if (host === CLIENT_PROGRAM_HOSTNAME) {
        fetchScenes();
      } else {
        if (localStorage.getItem("accessToken")) {
          fetchScenes();
        }
      }
    }, 500);

    return () => {
      clearTimeout(timer);
    };
  }, [query, filter, selectedEpisode]);

  const clickScript = () => {
    /* Function to take the user to the Script Page */
    history.push(
      `/${localStorage.getItem("projectSlug")}/script${
        epi && pro && episodeTitle
          ? `?episode=${epi}&project=${pro}&episodeTitle=${episodeTitle}`
          : ""
      }`
    );
  };

  useLayoutEffect(() => {
    if (projectType === "Television" && !epi) {
      history.push(
        `/${localStorage.getItem(
          "projectSlug"
        )}/episodes/create?nextPage=scenesPage`
      );
    }
  }, [projectType, history]);

  useEffect(() => {
    if (epi) {
      setSelectedEpisode(epi.toString());
    } else {
      setSelectedEpisode("");
    }
  }, [params, epi]);

  return (
    <div>
      <div className="">
      <TopBox
        title="Scenes Workspace"
        episodeTitle={`Episode ${episodeTitle}`}/>
      </div>
      <Row className="my-1">
        <Col xs={3} >
          <Button
            className={`${btnStyles.Button} ${btnStyles.Blue}`}
            onClick={() => history.goBack()}
          >
            Back
          </Button>
        </Col>
        <Col xs={3} className="px-0 text-center">
          <Button
            className={`${btnStyles.Button} px-md-3 ${btnStyles.Order}`}
            onClick={() => setShowNum((showNum) => !showNum)}
          >
            {" "}
            IMPORTANT
          </Button>
        </Col>
        <Col xs={3} className="px-0 text-center">
        {projectType !== "Television" ? (
          <Button
            className={`${btnStyles.Button} px-3 px-md-5 ${btnStyles.Order}`}
            onClick={() => clickScript()}
          >
            {" "}
            SCRIPT
          </Button>
      ) : (
          <Button
            className={`${btnStyles.Button} px-3 px-md-5 ${btnStyles.Order}`}
            onClick={() => clickScript()}
          >
            {" "}
            SCRIPT
          </Button>
      )}
        </Col>
        <Col xs={3} className="px-0 ">
        {currentUser &&
            currentUser?.groups.length > 0 &&
            (currentUser?.groups[0]?.name === "Admin" ||
              currentUser?.groups[0]?.name === "Superadmin" ||
              currentUser?.groups[0]?.name === "Admincreative") && (
          <Button
            className={`${btnStyles.Button} mt-1 float-right mr-3 ${btnStyles.Order}`}
            onClick={() => setShowInfoFreeze((showInfoFreeze) => !showInfoFreeze)}
          >
            {" "}
            FREEZE
          </Button>)}
        </Col>
      </Row>
      {/* tracker */}
      <Row className="my-3">
        <Col xs={12} className="px-0 text-center">
          <Button
            className={`${btnStyles.Button} ${btnStyles.WideTrack} ${btnStyles.Track}`}
            onClick={() => setShowTracker((showTracker) => !showTracker)}
          >
            {" "}
            PRODUCTION TRACKER
          </Button>
        </Col>
      </Row>
      {!showInfo ? "" : <Information />}
      {!showInfoFreeze ? "" : <InfoFreeze />}
      {!showNum ? "" : <InfoNumbers />}
      {!showTracker ? "" : <ProTrackerPage
      setShowTracker={setShowTracker} />}
      <h5 style={{ textTransform: 'uppercase'}} 
          className={`mt-1 mb-1 py-1 ${styles.SubTitle } text-center`}>
          Scenes
      </h5>        
      {/* Add Scene */}
      <Row className="mt-3">
        <Col className="text-center">
          {currentUser &&
            currentUser?.groups.length > 0 &&
            (currentUser?.groups[0]?.name === "Admin" ||
              currentUser?.groups[0]?.name === "Superadmin") && (
              <Button
                onClick={() =>
                  history.push(
                    `/${localStorage.getItem(
                      "projectSlug"
                    )}/scenes/create?episode=${epi}&project=${pro}&episodeTitle=${episodeTitle}`
                  )
                }
                className={`${btnStyles.Button} ${btnStyles.Wide2} ${btnStyles.Shed} `}
              >
                Create Scene
              </Button>
            )}
        </Col>
      </Row>
      {/* search freeze */}
      <Row>
        <Col className="mt-3" xs={12} sm={{ span: 6, offset: 3 }}>
          <Form
            onSubmit={(event) => event.preventDefault()}
          >
            <Form.Control
              value={query}
              onChange={(event) => setQuery(event.target.value)}
              type="text"
              className={`${styles.InputBar}`}
              placeholder="Search by scene number or location"
            />
           {/* Freeze component for the Super Admin only */}
            {/* <div>
              {currentUser?.groups[0]?.name === "Superadmin" && (
                <>
                <Row>
                  <FreezeScenes
                    selectedEpisode={selectedEpisode}
                    freezeStatus={scenes?.freeze_status}
                    freezeId={scenes?.freeze_id}
                    fetchScenes={fetchScenes}
                  />
                </Row>
                </>
              )}
            </div> */}
          </Form>
        </Col>
      </Row>
      {projectType !== "Television" && (
        <Row className="mt-1">
          <Col className="text-center" xs={6} md={3}>
            <Button
              className={`py-0 ${btnStyles.Button} ${btnStyles.Back}`}
              onClick={handleClickAct1}
            >
              Act One
            </Button>
          </Col>
          <Col className="text-center" xs={6} md={3}>
            <Button
              className={`py-0 ${btnStyles.Button} ${btnStyles.Back}`}
              onClick={handleClickAct2a}
            >
              Act Two A
            </Button>
          </Col>
          <Col className="text-center" xs={6} md={3}>
            <Button
              className={`py-0 mt-2 mt-md-0 ${btnStyles.Button} ${btnStyles.Back}`}
              onClick={handleClickAct2b}
            >
              Act Two B
            </Button>
          </Col>
          <Col className="text-center" xs={6} md={3}>
            <Button
              className={`py-0 mt-2 mt-md-0  ${btnStyles.Button} ${btnStyles.Back}`}
              onClick={handleClickAct3}
            >
              Act Three
            </Button>
          </Col>
        </Row>
      )}
      <hr className={`mt-0 mb-0 py-1 ${styles.BreakTitle}`}/>
      {/* render scenes */}
      <Row className="h-100 my-3 px-3">
        {hasLoaded ? (
          <>
            {scenes?.results?.length ? (
              scenes?.results?.map((scene, index) => {
                return ( 
                  <Col
                    key={scene.id}
                    xs={12}
                    sm={6}
                    md={4}
                    lg={3}
                    className="py-2 px-1 px-md-3 mx-0"
                  >
                    <SceneTop
                      className={`text-center ${styles.SceneCard}`}
                      fetchScenes={fetchScenes}
                      projectType={projectType}
                      episodeTitle={episodeTitle}
                      pro={pro}
                      epi={epi}
                      {...scene}
                      setScenes={setScenes}
                      
                      // style={{
                      //   backgroundImage: `url(${mo2a})`,
                      //   objectFit: "contain",
                      //   height: "100px",
                      //   width: "auto",
                      //   repeat: "no-repeat",
                      // }}
                    />
                  </Col>
                );
              })
            ) : (
              <Container className={appStyles.Content}>
                <Asset src={NoResults} message={message} />
              </Container>
            )}
          </>
        ) : (
          <Container className={appStyles.Content}>
            <Asset spinner />
          </Container>
        )}
      </Row>
    </div>
  );
};

export default ScenesPage;
